/**
 * RAF loops for Shop / Inventory / Profile cosmetic previews that have animation frames.
 */
import { ANIM_FRAME_MS } from "./shop-creator-fx";

const loopByCanvas = new WeakMap<HTMLCanvasElement, number>();

export function stopCosmeticPreviewLoop(canvas: HTMLCanvasElement | null | undefined) {
  if (!canvas) return;
  const id = loopByCanvas.get(canvas);
  if (id != null) {
    cancelAnimationFrame(id);
    loopByCanvas.delete(canvas);
  }
}

/**
 * Continuously calls `paint` about every ANIM_FRAME_MS while `isActive()` stays true
 * and the canvas remains in the DOM.
 */
export function startCosmeticPreviewLoop(
  canvas: HTMLCanvasElement,
  paint: () => void | Promise<void>,
  isActive: () => boolean = () => true,
) {
  stopCosmeticPreviewLoop(canvas);
  let last = 0;
  let painting = false;

  const tick = (ts: number) => {
    if (!canvas.isConnected || !isActive()) {
      stopCosmeticPreviewLoop(canvas);
      return;
    }
    if ((!last || ts - last >= ANIM_FRAME_MS) && !painting) {
      last = ts;
      painting = true;
      void Promise.resolve(paint()).finally(() => {
        painting = false;
      });
    }
    const id = requestAnimationFrame(tick);
    loopByCanvas.set(canvas, id);
  };

  const id = requestAnimationFrame(tick);
  loopByCanvas.set(canvas, id);
}
